import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { rydeColors } from "@ryde/theme";

/** Slash overlay: exclude-starred vs hollow include-all star. */
export const StarredIconExcludeWrap = styled.div.attrs<IStyledAttributes>(
  () => ({
    [DATA_E2E_KEY]: "starred-icon-exclude-wrap",
  }),
)`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
  overflow: visible;

  &::after {
    content: "";
    position: absolute;
    z-index: 1;
    left: 50%;
    top: 50%;
    width: 22px;
    height: 2px;
    background-color: ${rydeColors.darkerRed};
    transform: translate(-50%, -50%) rotate(-40deg);
    border-radius: 1px;
    pointer-events: none;
    box-shadow: 0 0 0 1px ${rydeColors.white};
  }
`;
